var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.6 1.046A9.447 9.447 0 0 0 3.905 3.68C2.028 5.499 1 7.912 1 10.5c0 3.274 1.694 6.316 4.5 8.081 2.435 1.531 5.581 1.841 8.32.819.855-.319 1.985-.949 2.5-1.394l.14-.121 2.5 2.494c1.743 1.738 2.554 2.52 2.677 2.581.353.177.717.088 1.064-.259.347-.347.436-.711.259-1.064-.061-.123-.843-.934-2.581-2.677l-2.494-2.5.121-.14c.243-.281.762-1.107.993-1.577 1.338-2.732 1.338-5.759.001-8.483-.734-1.495-2.035-2.926-3.467-3.814a9.59 9.59 0 0 0-5.933-1.4m1.623 1.997a7.504 7.504 0 0 1 6.381 5.08 7.47 7.47 0 0 1-.377 5.667 7.257 7.257 0 0 1-1.432 2.005 7.492 7.492 0 0 1-6.837 2.045c-2.486-.507-4.634-2.379-5.509-4.8a7.547 7.547 0 0 1 0-5.08A7.552 7.552 0 0 1 9.06 3.143a7.553 7.553 0 0 1 2.163-.1",
    fillRule: "evenodd",
    fill: "currentColor"
  })));
};

export default SvgSearch;